
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/briefing",
      function () {
        return require("private-next-pages/briefing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/briefing"])
      });
    }
  